import React, { Component } from "react";

export class ShowEntry extends Component {
  render() {
    const { id, attachments, notes, place, entry_info} = this.props.entry
    const { appointment_time } = entry_info
    return (
      <div className="row">
        <div className="content">
          <a href={'/admin/walk_in_entries'}> Back to Entries </a>
        </div>
        <div className="content">
          <h2>Name: { place.name } <br />
          Address: { place.vicinity }</h2>
          <p>Notes: { notes }</p>
          <p>Appontment: { appointment_time }</p>
        </div>
      </div>
    );
  }
}

export default ShowEntry;
